"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPOINTMENT_IN_PERSON_TITLE = exports.APPPOINTMENT_VIDEO_TITLE = exports.APPOINTMENT_PHONE_TITLE = void 0;
exports.APPOINTMENT_PHONE_TITLE = 'appointmentPhoneTitle';
exports.APPPOINTMENT_VIDEO_TITLE = 'appointmentVideoTitle';
exports.APPOINTMENT_IN_PERSON_TITLE = 'appointmentInPersonTitle';
//# sourceMappingURL=visitTypes.js.map